import { render, staticRenderFns } from "./background-parallax.vue?vue&type=template&id=edad8ffc&scoped=true&"
import script from "./background-parallax.vue?vue&type=script&lang=js&"
export * from "./background-parallax.vue?vue&type=script&lang=js&"
import style0 from "./background-parallax.vue?vue&type=style&index=0&id=edad8ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edad8ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VParallax})
